import { AlertTriangle, Clock, ShieldAlert, UserX, Users } from 'lucide-react';

const ICON = { session: UserX, hours: Clock, supervision: ShieldAlert, staff_hours: Users };
const LABEL = { session: 'Session not covered', hours: 'Client hours not filled', supervision: 'Supervision short', staff_hours: 'Staff over max hours' };

// Every coverage problem this week, grouped; session gaps open the cover finder.
export const GapsPanel = ({ gaps, blocks, onFix }) => {
  if (!gaps.length) {
    return <div className="rounded-2xl border border-[#C9DAD2] bg-[#EEF4F2] p-6 text-[#2F5D52]" data-testid="sched-gaps-none">Fully covered this week — no gaps.</div>;
  }
  return (
    <div className="space-y-2" data-testid="sched-gaps">
      {gaps.map((g, i) => {
        const Icon = ICON[g.kind] || AlertTriangle;
        const block = g.kind === 'session' ? blocks.find((b) => b.session_id === g.session_id && b.date === g.date) : null;
        return (
          <div key={i} className="flex items-center justify-between rounded-xl border border-[#E8C9C9] bg-white px-4 py-2.5" data-testid={`sched-gap-${i}`}>
            <div className="flex items-start gap-2.5 text-sm">
              <Icon size={16} className="text-[#8A3A3A] mt-0.5" />
              <div>
                <div className="font-semibold text-[#2D2833]">{LABEL[g.kind]} · {g.client_name}{g.date ? ` · ${g.date} ${g.start}–${g.end}` : ''}</div>
                <div className="text-[12px] text-[#8A3A3A]">{g.issues.join(' · ')}</div>
              </div>
            </div>
            {block && <button onClick={() => onFix(block)} className="text-[12px] font-semibold px-3 py-1.5 rounded-full bg-[#5E5068] text-white" data-testid={`sched-gap-fix-${i}`}>Find cover</button>}
            {g.kind !== 'session' && g.client_id && <button onClick={() => onFix({ addFor: g.client_id, type: g.kind === 'supervision' ? 'supervision' : 'direct' })}
              className="text-[12px] font-semibold px-3 py-1.5 rounded-full border border-[#5E5068] text-[#5E5068]" data-testid={`sched-gap-add-${i}`}>Add session</button>}
          </div>
        );
      })}
    </div>
  );
};

export default GapsPanel;
